/* LP Landing Kit · v1.1 — galería, ofertas, barra fija y scroll suave */
(function () {
  if (window.__lpLanding) return;
  window.__lpLanding = true;

  function initGallery(root) {
    root.querySelectorAll('[data-lp-gallery]').forEach(function (g) {
      if (g.__lp) return;
      g.__lp = true;
      var track = g.querySelector('[data-lp-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var media = g.parentElement;
      var thumbs = Array.prototype.slice.call(media.querySelectorAll('[data-lp-thumb]'));
      var counter = g.querySelector('[data-lp-current]');
      var idx = 0;

      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      }
      function update() {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i === idx) return;
        idx = i;
        if (counter) counter.textContent = i + 1;
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
        });
        var active = thumbs[i];
        if (active && active.parentElement) {
          var parent = active.parentElement;
          parent.scrollTo({ left: active.offsetLeft - parent.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
        }
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });

      var prev = g.querySelector('[data-lp-prev]');
      var next = g.querySelector('[data-lp-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      });
    });
  }

  function initOffers(root) {
    root.querySelectorAll('[data-lp-hero]').forEach(function (hero) {
      var form = hero.querySelector('#lp-buy-form');
      if (!form || form.__lp) return;
      form.__lp = true;
      var radios = form.querySelectorAll('.lp-offer__input');
      if (!radios.length) return;

      var priceEl = hero.querySelector('[data-lp-price]');
      var compareEl = hero.querySelector('[data-lp-compare]');
      var saveWrap = hero.querySelector('[data-lp-save-wrap]');
      var saveEl = hero.querySelector('[data-lp-save]');
      var stockEl = hero.querySelector('[data-lp-stock]');
      var stockN = hero.querySelector('[data-lp-stock-n]');
      var cta = hero.querySelector('[data-lp-cta]');
      var ctaText = hero.querySelector('[data-lp-cta-text]');
      var stickyPrice = hero.querySelector('[data-lp-sticky-price]');
      var showCompare = compareEl && !compareEl.hasAttribute('data-lp-never');

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          form.querySelectorAll('.lp-offer').forEach(function (o) {
            o.classList.toggle('is-active', o.contains(r));
          });
          var d = r.dataset;
          if (priceEl) priceEl.innerHTML = d.price;
          if (stickyPrice) stickyPrice.innerHTML = d.price;
          if (compareEl && showCompare) {
            compareEl.innerHTML = d.compare || '';
            compareEl.hidden = !d.compare;
          }
          if (saveWrap) saveWrap.hidden = !d.compare;
          if (saveEl) saveEl.textContent = '-' + (d.save || 0) + '%';
          if (stockEl) {
            var n = parseInt(d.stock || '0', 10);
            var limit = parseInt(stockEl.dataset.threshold || '0', 10);
            stockEl.hidden = !(n > 0 && n <= limit);
            if (stockN) stockN.textContent = n;
          }
          if (cta) {
            var ok = d.available === 'true';
            cta.disabled = !ok;
            if (ctaText) ctaText.textContent = ok ? cta.dataset.label : cta.dataset.soldout;
          }
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', r.value);
            window.history.replaceState({}, '', url.toString());
          } catch (e) {}
        });
      });
    });
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-lp-sticky]');
    var anchor = root.querySelector('[data-lp-cta-anchor]');
    if (!sticky || !anchor || sticky.__lp) return;
    sticky.__lp = true;
    var shown = null;
    var ticking = false;
    // Visible solo cuando el botón principal ya quedó por encima de la pantalla.
    function check() {
      ticking = false;
      var show = anchor.getBoundingClientRect().bottom < 0;
      if (show === shown) return;
      shown = show;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.querySelectorAll('a, button').forEach(function (el) {
        el.tabIndex = show ? 0 : -1;
      });
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#lp-buy"]');
      if (!a) return;
      var target = document.getElementById('lp-buy');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init(root) {
    initGallery(root);
    initOffers(root);
    initSticky(root);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    init(document);
    initAnchors();
  });

  // Editor de temas de Shopify: reiniciar al editar una sección
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
